import React, { useState, useEffect } from "react";
import pdfIcon from "../../../img/a.png";
import { SpecialZoomLevel, Viewer, Worker } from "@react-pdf-viewer/core";
import { defaultLayoutPlugin } from "@react-pdf-viewer/default-layout";
import "@react-pdf-viewer/core/lib/styles/index.css";
import "@react-pdf-viewer/default-layout/lib/styles/index.css";

const SMPdfGallery = ({ data }) => {
  const [selectedPdf, setSelectedPdf] = useState(null);
  const [fileName, setFileName] = useState("");
  const layoutPlugin = defaultLayoutPlugin();
  useEffect(() => {
    setSelectedPdf(null);
  }, [data]);

  const downloadPdf = (url, name = "document.pdf") => {
    const link = document.createElement("a");
    link.href = url;
    link.download = name;
    link.click();
  };

  return (
    <>
      {/* PDF Cards */}
      <div>
        <div className="d-flex gap-3 overflow-auto ">
          {data?.map((item, i) => (
            <div
              key={i}
              className="p-2 text-center glass-card border border-dark"
              style={{ width: "180px" }}
            >
              <img src={pdfIcon} alt="pdf" width={20} />

              <h6 className="mt-1 mb-1 small-lg text-truncate">{item.name}</h6>

              <p className="small text-muted mb-2" style={{ fontSize: "13px" }}>
                {item.description}
              </p>

              <div className="d-flex justify-content-center gap-1">
                <div
                  className="rounded-pill btn-card-soft px-2 py-1 small"
                  onClick={() => {
                    setSelectedPdf(item.pdf);
                    setFileName(item.name);
                  }}
                >
                  View
                </div>

                <div
                  className="rounded-pill btn-card-soft px-2 py-1 small"
                  onClick={() => downloadPdf(item.pdf, item.name)}
                >
                  Download
                </div>
              </div>
            </div>
          ))}
        </div>
        {selectedPdf && (
          <>
            <div
              onClick={() => setSelectedPdf(null)}
              style={{
                position: "fixed",
                inset: 0,
                background: "rgba(0,0,0,0.7)",
                zIndex: 9998,
              }}
            />

            <div
              style={{
                minHeight: "500px",
                position: "fixed",
                inset: "4%",
                background: "#fff",
                borderRadius: "12px",
                zIndex: 9999,
                display: "flex",
                flexDirection: "column",
              }}
            >
              <div className="d-flex justify-content-between align-items-center p-3 border-bottom">
                <h6 className="m-0">{fileName || "PDF Viewer"}</h6>

                <div className="d-flex gap-2">
                  <button
                    className="btn btn-sm btn-outline-danger"
                    onClick={() => setSelectedPdf(null)}
                  >
                    Close
                  </button>
                </div>
              </div>

              <div style={{ height: "100vh" }}>
                <Worker workerUrl="https://unpkg.com/pdfjs-dist@3.11.174/build/pdf.worker.min.js">
                  <Viewer
                    fileUrl={selectedPdf}
                    plugins={[layoutPlugin]}
                    defaultScale={1.2}
                  />
                </Worker>
              </div>
            </div>
          </>
        )}
      </div>
    </>
  );
};

export default SMPdfGallery;
